import React, { FC, useRef, useState } from 'react';
import {
  Stack,
  Button,
  Typography,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  IconButton,
  Box,
  Collapse,
  Slider,
} from '@mui/material';
import { Edit } from '../../constructor/work/Edit';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { ItemSelectSupport } from './ItemSelectSupport';
import { SelectSupportType } from './SelectSupportType';
import { InputHeightPoint } from '../InputHeightPoint';

const TIMBERS = [
  { title: '50 x 50', offsets: '700x400', mode: 'Дерево' },
  { title: '50 x 70', offsets: '800x400', mode: 'Дерево' },
  { title: '50 x 80', offsets: '900x400', mode: 'Дерево' },

  { title: '20 x 60', offsets: '500x400', mode: 'Алюм.' },
  { title: '40 x 60', offsets: '800x400', mode: 'Алюм.' },
  { title: '40 x 40', offsets: '700x400', mode: 'Алюм.' },

  { title: '30 x 50', offsets: '400x400', mode: 'ДПК' },
];
interface Props {
  setDisableRootControl(val: boolean): void;
}
export const CalcSupportsForTimber: FC<Props> = ({ setDisableRootControl }) => {
  const [selectTimber, setSelectTimber] = useState(TIMBERS[0]);
  const [isCollapseRadio, setIsCollapseRadio] = useState(true);
  const [isDisableButton, setIsDisableButton] = useState<boolean>(
    !!Edit.sectionsObjects && !Edit.supportsGroupTimber
  );
  const [valueDeg, setValueDeg] = useState(() => {
    if (Edit.supportsGroupTimber && Edit.supportsGroupTimber.directionBuildDeg) {
      return Edit.supportsGroupTimber.directionBuildDeg;
    }
    return 0;
  });
  const depthRef = useRef(25);

  const handlerCalculationSupports = () => {
    const data = selectTimber.offsets.split('x');
    const offsetX = +data[0] / 1000;
    const offsetZ = +data[1] / 1000;
    const depthTimber =
      +selectTimber.title.replace(/\s/g, '').split('x')[1] / 1000 + depthRef.current / 1000;
    Edit.addSupportsObjects({depthTile: depthTimber, offsetX, offsetZ, directionBuildDeg: valueDeg});
    setIsDisableButton(false);
    setDisableRootControl(true);
  };

  const getItemSelectSupports = () => {
    if (Edit?.supportsGroupTimber?.selectSupports) {
      const _selSupp = Edit.supportsGroupTimber.selectSupports;
      const keysSupport = Object.keys(Edit.supportsGroupTimber.selectSupports);
      keysSupport.sort();
      return keysSupport.map(item => {
        return (
          <ItemSelectSupport
            key={item}
            color={_selSupp[item].color}
            title={item}
            quantity={_selSupp[item].quantity}
          />
        );
      });
    }
  };
  const changeHeightPoint = (heightPoint: number) => {
    depthRef.current = +heightPoint;
  };
  const removeSupports = () => {
    Edit.removeSupportsObjects();
    setIsDisableButton(true);
    setDisableRootControl(false);
    // setValueDeg(0);
  };
  const handlerChangeTimberWood = (event: React.ChangeEvent<HTMLInputElement>) => {
    const data = JSON.parse(event.target.value);

    setSelectTimber(data);
  };
  const getCompensatingLining = () => {
    if (Edit.supportsGroupTimber?.compensatingLining) {
      return (
        <Typography mt={3} mb={3} color="#fff">
          {`Кол - во компенсирующих подкладок: ${Edit.supportsGroupTimber?.compensatingLining} шт.`}
        </Typography>
      );
    }
    return null;
  };

  return (
    <Stack display="flex" flexDirection="column" pb={10}>
      <Button
        disabled={!isDisableButton}
        fullWidth
        variant="contained"
        onClick={handlerCalculationSupports}
        sx={{
          marginBottom: '30px',
          flexDirection: 'column',
          '&:disabled': {
            color: 'rgba(255,255,255,0.53)',
            backgroundColor: 'rgba(0,0,0,0.45)',
          },
        }}
      >
        <Typography fontSize="12px" component="span">
          Рассчитать для бруса
        </Typography>
        <Typography fontSize="12px" component="span">
          {`${selectTimber.title} (${selectTimber.mode})`}
        </Typography>
      </Button>
      <Button
        fullWidth
        variant="contained"
        onClick={removeSupports}
        sx={{
          marginBottom: '30px',
          flexDirection: 'column',
          '&:disabled': {
            color: 'rgba(255,255,255,0.53)',
            backgroundColor: 'rgba(0,0,0,0.45)',
          },
        }}
      >
        Удалить опоры
      </Button>
      <Box mb={2}>
        <InputHeightPoint
          uuid=""
          changeHeightObject={changeHeightPoint}
          namePoint=""
          text={depthRef.current.toString()}
          label="Высота доски"
          width="100%"
          disable={!!Edit?.supportsGroupTimber}
        />
      </Box>
      <FormControl fullWidth disabled={!!Edit?.supportsGroupTimber}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <FormLabel
            sx={{
              color: '#ffffff',
              '&.Mui-disabled': {
                color: '#6e6e6e',
              },
            }}
          >
            <Typography>Размер бруса</Typography>
          </FormLabel>
          <IconButton
            sx={{ color: '#fff' }}
            onClick={() => {
              setIsCollapseRadio(!isCollapseRadio);
            }}
          >
            {!isCollapseRadio ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
          </IconButton>
        </Box>
        <Collapse in={isCollapseRadio}>
          <RadioGroup value={JSON.stringify(selectTimber)} onChange={handlerChangeTimberWood}>
            {TIMBERS.map(item => (
              <FormControlLabel
                sx={{ color: '#ffffff' }}
                key={item.title}
                value={JSON.stringify(item)}
                control={
                  <Radio
                    sx={{
                      '&.Mui-disabled': {
                        color: '#6e6e6e',
                      },
                    }}
                  />
                }
                label={`${item.title} mm (${item.mode})`}
              />
            ))}
          </RadioGroup>
        </Collapse>
      </FormControl>
      <Box color="white" mt={3}>
        <Typography
          color="white"
          component="span"
        >{`Направление расположения бруса ${valueDeg}°`}</Typography>
        <Slider
          sx={{ marginTop: '20px' }}
          value={valueDeg}
          onChange={(e, v) => setValueDeg(+v)}
          valueLabelDisplay="auto"
          step={5}
          min={0}
          max={90}
        />
      </Box>
      <SelectSupportType />
      <Typography mt={3} mb={3} color="#fff">
        Кол-во опор:
      </Typography>
      {getItemSelectSupports()}
      {getCompensatingLining()}
    </Stack>
  );
};
